import { Spot, SpotClient, fetchSpots } from '@frontend/spot';
import { useEffect, useMemo, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from '../../redux/store';
import { SpotSelectProps } from './spot-select.component';

interface ViewProps {
    options: { value: string; label: string }[];
    value?: { value: string; label: string };
    onScrollToBottom: () => void;
    search: (inputValue: string, callback: (options: { value: any; label: string }[]) => void) => void;
}

const pageSize = '25';
const useSpotSelect = (props: SpotSelectProps): ViewProps => {
    const dispatch = useAppDispatch();
    const timer = useRef<NodeJS.Timeout | null>(null);
    const [count, changeCount] = useState<number>(0);
    const [index, changeIndex] = useState<number>(0);
    const spotState = useAppSelector((state) => state.spots);
    const [options, changeOptions] = useState<{ value: string; label: string }[]>([]);
    const value = useMemo(() => {
        if (typeof props.value == 'string') return options.find((o) => o && o.value == props.value);
        return props.value;
    }, [props.value, options]);

    useEffect(() => {
        dispatch(fetchSpots({ index: index.toString(), size: pageSize }));
    }, [index]);

    useEffect(() => {
        if (spotState.spots) {
            changeCount(spotState.spots.count);
            changeOptions(mapResultSetToOptions(spotState.spots.results));
        }
    }, [spotState.spots]);

    const search = (inputValue: string, callback: (options: { value: any; label: string }[]) => void) => {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(() => {
            SpotClient.fetchSpots({ search: inputValue, index: '0', size: pageSize }).then((result) => {
                callback(mapResultSetToOptions(result.results));
            });
        }, 500);
    };

    const onScrollToBottom = () => {
        if (count / parseInt(pageSize) > 1 && parseInt(pageSize) * index < count) {
            changeIndex(index + 1);
        }
    };

    return {
        options,
        value,
        onScrollToBottom,
        search
    };
};

function mapResultSetToOptions(spots: Spot[]): { value: any; label: string }[] {
    return spots.map((s) => ({ value: s.id, label: s.name }));
}

export default useSpotSelect;
